export default function AtcCurrencyByCode($filter, $sce, commonCurrency) {
    'ngInject';

    return function(input, currencyCode) {
        let code = commonCurrency[currencyCode]
            ? commonCurrency[currencyCode].symbol
            : currencyCode;
        if (code && code.length > 1) {
            code += ' ';
        }
        return $sce.trustAsHtml((input < 0 ? '-' : '') + $filter('currency')(input * (input < 0 ? -1 : 1), code));
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/filters/atcCurrencyByCode.filter.js